import { isEmailBuilderTextEditableTarget } from "./emailBuilderHistoryHotkeys";

export type TEmailBuilderBlockClipboardAction = "copy" | "cut" | "paste";

export interface IEmailBuilderBlockClipboardHotkeyEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  target: EventTarget | null;
}

export function resolveEmailBuilderBlockClipboardHotkey(
  event: IEmailBuilderBlockClipboardHotkeyEvent,
): TEmailBuilderBlockClipboardAction | null {
  if (isEmailBuilderTextEditableTarget(event.target)) {
    return null;
  }

  if (event.shiftKey || event.altKey) {
    return null;
  }

  const modifierPressed = event.metaKey || event.ctrlKey;
  if (!modifierPressed) {
    return null;
  }

  const key = event.key.toLowerCase();
  if (key === "c") {
    return "copy";
  }
  if (key === "x") {
    return "cut";
  }
  if (key === "v") {
    return "paste";
  }

  return null;
}
